/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import styled from 'styled-components';

import { FlowMenu } from './ToolbarMenu';
import { Button } from '@common/Button';
import { Stack } from '@mui/material';
import { State, flowActions } from '@store/index';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { InfoOutlined } from '@mui/icons-material';

const Container = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.background.standard};
  color: white;
  height: 35px;
  padding: 0 14px;

  &.MuiPopover-paper {
    border-radius: 6px;
  }
`;

export const TopToolbar: React.FC = () => {
  const dispatch = useDispatch();

  const { enqueueSnackbar } = useSnackbar();

  const triggerCommand = useSelector((state: State) => state.tabs.active.commands).find((item) => item.config.trigger);
  const tab = useSelector((state: State) => state.tabs.active);

  const openInfo = () => {
    if (!triggerCommand)
      return enqueueSnackbar('You do not have a trigger node. Add a "Request" node to execute this workflow.', {
        variant: 'warning',
        autoHideDuration: 5000,
      });

    dispatch(flowActions.setViewExecuteInfo(true));
  };

  return (
    <Container>
      <FlowMenu />
      <Stack direction='row' spacing={0.5}>
        {/* <Tooltip arrow title='Deploy environments are coming soon, stay tuned!' placement='left'>
          <span>
            <Button tiny disabled onClick={openInfo} startIcon={<RocketLaunchOutlined />}>
              Deploy
            </Button>
          </span>
        </Tooltip> */}
        <Button tiny onClick={openInfo} disabled={tab?.unstored} startIcon={<InfoOutlined />}>
          Execute
        </Button>
      </Stack>
    </Container>
  );
};
